import * as React from "react"
import Column from "src/components/column"
import Text from "src/components/text"

interface Props {
  title?: string
}

const EmptyLeases = ({ title = "You currently don’t have any leases" }: Props) => {
  return (
    <Column alignItems="center" justifyContent="center" height="500">
      <Text fontSize={24} fontWeight={600}>
         📪 {title}
      </Text>
    </Column>
  )
}

export default EmptyLeases
